<div class="ec-container">

  <!-- Header -->
  <div class="ec-header">
    <div>
      <h1 class="ec-title">{{ 'EMAIL_COMPLAINTS' | translate }}</h1>
      <p class="ec-subtitle">{{ 'EMAIL_COMPLAINTS_SUBTITLE' | translate }}</p>
    </div>

    <!-- Global Date Range -->
    <div class="ec-date-range">
      <button class="ec-range-btn" [class.active]="dateRange === 'today'" [attr.aria-pressed]="dateRange === 'today'" (click)="setDateRange(dateRange === 'today' ? null : 'today')">{{ 'EC_TODAY' | translate }}</button>
      <button class="ec-range-btn" [class.active]="dateRange === 'week'"  [attr.aria-pressed]="dateRange === 'week'"  (click)="setDateRange(dateRange === 'week'  ? null : 'week')">{{ 'EC_THIS_WEEK' | translate }}</button>
      <button class="ec-range-btn" [class.active]="dateRange === 'month'" [attr.aria-pressed]="dateRange === 'month'" (click)="setDateRange(dateRange === 'month' ? null : 'month')">{{ 'EC_THIS_MONTH' | translate }}</button>
      <div class="ec-date-separator"></div>
      <mat-form-field appearance="outline" class="ec-mat-date">
        <mat-label>{{ 'EC_FROM' | translate }}</mat-label>
        <input matInput [matDatepicker]="fromPicker" [(ngModel)]="customFrom" (ngModelChange)="onCustomDateChange()" [max]="customTo" />
        <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="ec-mat-date">
        <mat-label>{{ 'EC_TO' | translate }}</mat-label>
        <input matInput [matDatepicker]="toPicker" [(ngModel)]="customTo" (ngModelChange)="onCustomDateChange()" [min]="customFrom" />
        <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>
      <button class="ec-range-clear" *ngIf="hasDateFilter" (click)="clearDateRange()" [title]="'EC_CLEAR_DATE_FILTER' | translate" [attr.aria-label]="'EC_CLEAR_DATE_FILTER' | translate">×</button>
    </div>
  </div>

  <!-- Stat Cards -->
  <div class="ec-cards">

    <div class="ec-card ec-card-total" role="button" tabindex="0"
         [class.active]="activeCard === 'all'" [attr.aria-pressed]="activeCard === 'all'"
         (click)="setActiveCard('all')" (keydown.enter)="onCardKeydown($event, 'all')" (keydown.space)="onCardKeydown($event, 'all')">
      <div class="ec-card-icon">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          <polyline points="22,6 12,13 2,6"/>
        </svg>
      </div>
      <div class="ec-card-body">
        <span class="ec-card-count">{{ counts ? counts.total : '—' }}</span>
        <span class="ec-card-label">{{ 'EC_TOTAL_EMAILS' | translate }}</span>
      </div>
    </div>

    <div class="ec-card ec-card-completed" role="button" tabindex="0"
         [class.active]="activeCard === 'white-listed'" [attr.aria-pressed]="activeCard === 'white-listed'"
         (click)="setActiveCard('white-listed')" (keydown.enter)="onCardKeydown($event, 'white-listed')" (keydown.space)="onCardKeydown($event, 'white-listed')">
      <div class="ec-card-icon">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
          <polyline points="22,4 12,14.01 9,11.01"/>
        </svg>
      </div>
      <div class="ec-card-body">
        <span class="ec-card-count">{{ counts ? counts.completed : '—' }}</span>
        <span class="ec-card-label">{{ 'EC_COMPLETED_EMAILS' | translate }}</span>
      </div>
    </div>

    <div class="ec-card ec-card-pending" role="button" tabindex="0"
         [class.active]="activeCard === 'grey-listed'" [attr.aria-pressed]="activeCard === 'grey-listed'"
         (click)="setActiveCard('grey-listed')" (keydown.enter)="onCardKeydown($event, 'grey-listed')" (keydown.space)="onCardKeydown($event, 'grey-listed')">
      <div class="ec-card-icon">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10"/>
          <polyline points="12,6 12,12 16,14"/>
        </svg>
      </div>
      <div class="ec-card-body">
        <span class="ec-card-count">{{ counts ? counts.pending : '—' }}</span>
        <span class="ec-card-label">{{ 'EC_PENDING_EMAILS' | translate }}</span>
      </div>
    </div>

    <div class="ec-card ec-card-rejected" role="button" tabindex="0"
         [class.active]="activeCard === 'black-listed'" [attr.aria-pressed]="activeCard === 'black-listed'"
         (click)="setActiveCard('black-listed')" (keydown.enter)="onCardKeydown($event, 'black-listed')" (keydown.space)="onCardKeydown($event, 'black-listed')">
      <div class="ec-card-icon">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10"/>
          <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
        </svg>
      </div>
      <div class="ec-card-body">
        <span class="ec-card-count">{{ counts ? counts.rejected : '—' }}</span>
        <span class="ec-card-label">{{ 'EC_REJECTED_EMAILS' | translate }}</span>
      </div>
    </div>

  </div>

  <!-- Counts load failure -->
  <div class="ec-counts-error" *ngIf="countsError">
    <span>{{ 'EC_COUNTS_ERROR' | translate }}</span>
    <button class="ec-retry-btn" (click)="retryCounts()">{{ 'EC_RETRY' | translate }}</button>
  </div>

  <!-- List Section -->
  <ng-container *ngIf="activeCard !== null">

    <!-- Section Label + Refresh -->
    <div class="ec-list-header">
      <span class="ec-list-title">{{ activeCardLabelKey | translate }}</span>
      <button class="ec-refresh-btn" (click)="refresh()" [title]="'EC_REFRESH' | translate" [attr.aria-label]="'EC_REFRESH' | translate">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <polyline points="23,4 23,10 17,10"/>
          <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
        </svg>
        {{ 'EC_REFRESH' | translate }}
      </button>
    </div>

    <!-- Filter Bar -->
    <div class="ec-filter-bar">

      <!-- Search -->
      <mat-form-field appearance="outline" class="ec-mat-search">
        <mat-label>{{ 'EC_SEARCH' | translate }}</mat-label>
        <span matPrefix class="ec-search-prefix">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        </span>
        <input matInput [placeholder]="'EC_SEARCH_PLACEHOLDER' | translate" [(ngModel)]="searchText" (ngModelChange)="onSearchInput()" />
        <button matSuffix *ngIf="searchText" class="ec-search-clear" (click)="clearSearch()" [attr.aria-label]="'EC_CLEAR_SEARCH' | translate">×</button>
      </mat-form-field>

      <!-- Intent Group -->
      <mat-form-field appearance="outline" class="ec-mat-select" *ngIf="showIntentFilter">
        <mat-label>{{ 'EC_INTENT' | translate }}</mat-label>
        <mat-select [ngModel]="intentGroup ?? ''" (ngModelChange)="setIntentGroup($event || null)">
          <mat-option value="">{{ 'EC_ALL' | translate }}</mat-option>
          <mat-option *ngFor="let g of intentGroups" [value]="g">{{ 'EC_INTENT_' + g | translate }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Greylist Type -->
      <mat-form-field appearance="outline" class="ec-mat-select" *ngIf="showGreylistTypeFilter">
        <mat-label>{{ 'EC_TYPE' | translate }}</mat-label>
        <mat-select [ngModel]="greylistType" (ngModelChange)="setGreylistType($event)">
          <mat-option value="ALL">{{ 'EC_ALL_TYPES' | translate }}</mat-option>
          <mat-option value="DOMAIN">{{ 'UNTRUSTED_DOMAIN' | translate }}</mat-option>
          <mat-option value="INFO">{{ 'MISSING_FIELDS' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Needs Review -->
      <mat-form-field appearance="outline" class="ec-mat-select" *ngIf="showNeedsReviewFilter">
        <mat-label>{{ 'EC_REVIEW' | translate }}</mat-label>
        <mat-select [ngModel]="needsReview === null ? '' : needsReview.toString()" (ngModelChange)="setNeedsReview($event === '' ? null : $event === 'true')">
          <mat-option value="">{{ 'EC_ALL' | translate }}</mat-option>
          <mat-option value="true">{{ 'NEEDS_REVIEW' | translate }}</mat-option>
          <mat-option value="false">{{ 'EC_REVIEWED' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Reason -->
      <mat-form-field appearance="outline" class="ec-mat-select" *ngIf="showBlacklistReasonFilter">
        <mat-label>{{ 'EC_REASON' | translate }}</mat-label>
        <mat-select [ngModel]="blacklistReason ?? ''" (ngModelChange)="setBlacklistReason($event || null)">
          <mat-option value="">{{ 'EC_ALL_REASONS' | translate }}</mat-option>
          <mat-option *ngFor="let r of blacklistReasons" [value]="r.value">{{ r.labelKey | translate }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Sort -->
      <mat-form-field appearance="outline" class="ec-mat-select">
        <mat-label>{{ 'EC_SORT' | translate }}</mat-label>
        <mat-select [ngModel]="sortDir" (ngModelChange)="setSortDir($event)">
          <mat-option value="desc">{{ 'EC_NEWEST_FIRST' | translate }}</mat-option>
          <mat-option value="asc">{{ 'EC_OLDEST_FIRST' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Clear filters -->
      <button class="ec-clear-filters" *ngIf="hasActiveListFilters" (click)="clearListFilters()">
        {{ 'EC_CLEAR_FILTERS' | translate }}
      </button>

    </div>

    <!-- Fetching bar -->
    <div *ngIf="isLoading" class="ec-fetching-bar" role="progressbar" [attr.aria-label]="'EC_LOADING' | translate">
      <div class="ec-fetching-progress"></div>
    </div>

    <!-- Error -->
    <div *ngIf="!isLoading && errorMessage" class="ec-empty-state">
      <p class="ec-error-text">{{ errorMessage | translate }}</p>
      <button class="ec-retry-btn" (click)="refresh()">{{ 'EC_RETRY' | translate }}</button>
    </div>

    <!-- Empty -->
    <div *ngIf="!isLoading && !errorMessage && emails.length === 0" class="ec-empty-state">
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="color:#d1d5db;margin-bottom:12px" aria-hidden="true">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
        <polyline points="22,6 12,13 2,6"/>
      </svg>
      <p>{{ (hasActiveListFilters ? 'EC_NO_EMAILS_FILTERED' : 'EC_NO_EMAILS') | translate }}</p>
    </div>

    <!-- Email Rows -->
    <div class="ec-list" *ngIf="!errorMessage" [attr.aria-busy]="isLoading">
      <div
        *ngFor="let email of emails; trackBy: trackByEmail"
        class="ec-row"
        role="button"
        tabindex="0"
        (click)="viewEmail(email)"
        (keydown.enter)="viewEmail(email)"
      >
        <div class="ec-sender">
          <span class="ec-sender-name">{{ email.senderDisplayName || email.senderEmail }}</span>
          <span *ngIf="email.senderDisplayName && email.senderDisplayName !== email.senderEmail" class="ec-sender-email">{{ email.senderEmail }}</span>
        </div>

        <div class="ec-subject-col">
          <span class="ec-subject">{{ email.subject }}</span>
          <div class="ec-badges">
            <span class="ec-badge ec-badge-registered" *ngIf="email.registrationStatus === 'REGISTERED'">{{ 'REGISTERED' | translate }}</span>
            <span class="ec-badge ec-badge-failed"     *ngIf="email.registrationStatus === 'FAILED'">{{ 'REG_FAILED' | translate }}</span>
            <span class="ec-badge ec-badge-pending"    *ngIf="email.parsingStatus === 'PENDING_INFO'">{{ 'PENDING_INFO' | translate }}</span>
            <span class="ec-badge ec-badge-review"     *ngIf="email.needsReview">{{ 'NEEDS_REVIEW' | translate }}</span>
            <span class="ec-badge ec-badge-domain"     *ngIf="email.greylistType === 'DOMAIN'">{{ 'UNTRUSTED_DOMAIN' | translate }}</span>
            <span class="ec-badge ec-badge-info"       *ngIf="email.greylistType === 'INFO'">{{ 'MISSING_FIELDS' | translate }}</span>
            <span class="ec-badge ec-badge-intent"     *ngIf="email.intentGroup">{{ 'EC_INTENT_' + (email.intentGroup | uppercase) | translate }}</span>
            <span class="ec-reply-count" *ngIf="email.replyCount && email.replyCount > 0" [attr.aria-label]="'EC_REPLIES' | translate">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
              {{ email.replyCount }}
            </span>
          </div>
        </div>

        <div class="ec-date">{{ email.receivedAt | relativeDate }}</div>

        <div class="ec-actions">
          <button
            *ngIf="hasComplaintAction(email)"
            class="ec-action-btn"
            (click)="viewComplaintData(email); $event.stopPropagation()"
            [title]="'VIEW_COMPLAINT_DATA' | translate"
            [attr.aria-label]="'VIEW_COMPLAINT_DATA' | translate"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14,2 14,8 20,8"/>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div class="ec-pagination" *ngIf="totalElements > 0">
      <span class="ec-pagination-info">{{ 'EC_PAGE_INFO' | translate:{ current: currentPage + 1, total: totalPages, count: totalElements } }}</span>
      <div class="ec-pagination-controls">
        <mat-form-field appearance="outline" class="ec-mat-select ec-page-size">
          <mat-label>{{ 'EC_PAGE_SIZE' | translate }}</mat-label>
          <mat-select [ngModel]="pageSize" (ngModelChange)="setPageSize($event)">
            <mat-option *ngFor="let s of pageSizes" [value]="s">{{ s }}</mat-option>
          </mat-select>
        </mat-form-field>
        <button class="ec-page-btn" (click)="previousPage()" [disabled]="currentPage === 0" [attr.aria-label]="'PREVIOUS' | translate">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="15,18 9,12 15,6"/></svg>
        </button>
        <button class="ec-page-btn" (click)="nextPage()" [disabled]="currentPage >= totalPages - 1" [attr.aria-label]="'NEXT' | translate">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="9,18 15,12 9,6"/></svg>
        </button>
      </div>
    </div>

  </ng-container>

</div>
